const formMessages = {
  email: {
    isRequired: 'Email address is required.',
    isValid: 'Invalid email address. Please use the format example@email.com',
  },
};

export default formMessages;
